import styled from 'styled-components';

import { FontSizes, FontWeights, Text, units } from '@calm-web/design-system';

export const Container = styled.div`
	margin-bottom: 2rem;
`;

export const Header = styled(Text).attrs({
	el: 'h2',
	weight: FontWeights.Medium,
	size: FontSizes['2xl'],
	letterSpacing: '0.25px',
	color: 'gray8',
	noMargin: true,
	align: 'center',
})`
	margin-top: ${units(5)};
	margin-bottom: ${units(4)};
`;

export const PaymentHr = styled.hr`
	margin-bottom: ${units(3)};
	opacity: 0.2;
`;
